<script lang="ts" setup>
    import type { ToasterProps } from 'vue-sonner';
    import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon, XIcon } from 'lucide-vue-next';
    import { Toaster as Sonner } from 'vue-sonner';
    import { cn } from '../utils';

    const props = defineProps<ToasterProps>();
</script>

<template>
    <Sonner
        :class="cn('toaster group text-base', props.class)"
        :style="{
            '--border-radius': 'var(--radius)',
            '--normal-bg': 'var(--color-background-primary)',
            '--normal-text': 'var(--color-content-primary)',
            '--normal-border': 'var(--color-background-primary)',
            '--success-bg': 'var(--color-background-positive)',
            '--success-text': 'var(--color-content-positive)',
            '--success-border': 'var(--color-background-positive)',
            '--error-bg': 'var(--color-background-negative)',
            '--error-text': 'var(--color-content-negative)',
            '--error-border': 'var(--color-background-negative)',
        }"
        v-bind="props"
    >
        <template #success-icon>
            <CircleCheckIcon class="size-4" />
        </template>
        <template #info-icon>
            <InfoIcon class="size-4" />
        </template>
        <template #warning-icon>
            <TriangleAlertIcon class="size-4" />
        </template>
        <template #error-icon>
            <OctagonXIcon class="size-4" />
        </template>
        <template #loading-icon>
            <div>
                <Loader2Icon class="size-4 animate-spin" />
            </div>
        </template>
        <template #close-icon>
            <XIcon class="size-4" />
        </template>
    </Sonner>
</template>
